exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#close-game[data-v-4f84059f]{position:absolute;top:7px;left:7px;font-size:1.4rem;background-color:#000;color:#fff;padding:.2rem .6rem;border-radius:.2rem;cursor:pointer;z-index:10001}", ""]);

// exports
